import { c as _c } from "react/compiler-runtime";
import { PillCount } from "@/components/domain/pill-count";
type DnsGroupColor = "blue" | "cyan" | "green" | "orange" | "purple" | "indigo" | "slate";
export function DnsGroup(t0) {
  const $ = _c(13);
  const {
    title,
    children,
    color: t1,
    count
  } = t0;
  const color = t1 === undefined ? "slate" : t1;
  const actualCount = count ?? (Array.isArray(children) ? children.length : 1);
  if (actualCount === 0) {
    return null;
  }
  let t2;
  if ($[0] !== title) {
    t2 = <div className="text-[11px] tracking-[0.08em] text-foreground/70 uppercase dark:text-foreground/80">{title}</div>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== actualCount || $[3] !== color) {
    t3 = <PillCount count={actualCount} color={color} />;
    $[2] = actualCount;
    $[3] = color;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex items-center gap-2 leading-none">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children) {
    t5 = <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">{children}</div>;
    $[8] = children;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="space-y-2">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}